import { render, staticRenderFns } from "./CVTypeResumeUpload.vue?vue&type=template&id=33aaeaf6&scoped=true"
import script from "./CVTypeResumeUpload.vue?vue&type=script&lang=js"
export * from "./CVTypeResumeUpload.vue?vue&type=script&lang=js"
import style0 from "./CVTypeResumeUpload.vue?vue&type=style&index=0&id=33aaeaf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aaeaf6",
  null
  
)

export default component.exports